import React, {useEffect, useState} from 'react';
import { withStyles } from "@mui/styles";
import { Styles } from "../../../../config/design/styles";
import {Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography} from '@mui/material';
import {connect} from "trim-redux";
import {useTranslation} from "react-i18next";
import {Close} from "@mui/icons-material";
import Button from "@mui/material/Button";
import {useLocation, useNavigate} from "react-router-dom"; // Import useMediaQuery and Theme

function LoginDialog({isAuth,open, setOpen }) {
    const { t } = useTranslation();
    const navigation = useNavigate();
    const location = useLocation();
    const handleLogin = () => {
        localStorage.setItem("redirect", location.pathname);
        navigation('/login');
    }

    return (
        <>
            {
                !isAuth &&
                <>
                    <Dialog  open={open} onClose={() => setOpen(false)}>
                        <DialogTitle>
                            {t('login')}
                            <IconButton
                                onClick={() => setOpen(false)}
                                style={{position:"absolute",right:15,top:15}}
                                size="small"
                            >
                                <Close className="lucide-icon"/>
                            </IconButton>
                        </DialogTitle>
                        <DialogContent>
                            <Typography>{t('loginToDoThis')}</Typography>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={() => handleLogin()}
                            >
                                {t('login')}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </>
            }

        </>

    );
}
const mapStateToProps = (state) => ({
    isAuth: state.isAuth,
});

export default withStyles(Styles)(connect(mapStateToProps)(LoginDialog));
